import {
  PatientsPaginationRequestDtoStatusEnum,
  type PatientDto,
} from "libs/cellera-sdk";

import type { Patient } from "types";

export const formatPatientName = (patient: Patient): string => {
  const parts = [patient.firstName];
  if (patient.middleName) {
    parts.push(patient.middleName);
  }
  parts.push(patient.lastName);
  return parts.join(" ");
};

export const mapPatientDtoToPatient = (dto: PatientDto): Patient => {
  const birthDate = (() => {
    if (!dto.birthDate) {
      return null;
    }

    const dateValue =
      dto.birthDate instanceof Date ? dto.birthDate : new Date(dto.birthDate);

    return Number.isNaN(dateValue.getTime()) ? null : dateValue.toISOString();
  })();

  return {
    patientId: dto.patientId ?? "",
    firstName: dto.firstName ?? "",
    lastName: dto.lastName ?? "",
    middleName: dto.middleName ?? null,
    gender: dto.gender ?? null,
    birthDate,
    photoUrl: dto.photoUrl ?? null,
    email: dto.email ?? null,
    phone: dto.phone ?? null,
    phoneCountryCode: dto.phoneCountryCode ?? null,
    phoneCountryIso2: dto.phoneCountryIso2 ?? null,
    status:
      (dto.status as PatientsPaginationRequestDtoStatusEnum) ??
      PatientsPaginationRequestDtoStatusEnum.Requesting,
  };
};
